/**
 * S3 Key Storage Service
 * Stores S3 object keys by videoGuid for use when accepting recordings
 */

class S3KeyStorage {
  private keys: Map<string, string> = new Map();

  set(videoGuid: string, s3Key: string): void {
    this.keys.set(videoGuid, s3Key);
    console.log(`✅ [S3KeyStorage.set] Stored key for videoGuid: ${videoGuid}`, {
      s3Key: s3Key.substring(0, 60) + '...',
      totalKeysStored: this.keys.size
    });
  }

  get(videoGuid: string): string | undefined {
    const key = this.keys.get(videoGuid);
    console.log(`🔍 [S3KeyStorage.get] Retrieving key for videoGuid: ${videoGuid}`, {
      found: !!key,
      s3Key: key ? key.substring(0, 60) + '...' : 'NOT FOUND',
      totalKeysInStorage: this.keys.size,
      allStoredGuids: Array.from(this.keys.keys())
    });
    return key;
  }

  delete(videoGuid: string): void {
    const existed = this.keys.has(videoGuid);
    this.keys.delete(videoGuid);
    console.log(`🗑️ [S3KeyStorage.delete] Deleted key for videoGuid: ${videoGuid}`, {
      existed,
      remainingKeys: this.keys.size
    });
  }

  clear(): void {
    const count = this.keys.size;
    this.keys.clear();
    console.log(`🧹 [S3KeyStorage.clear] Cleared all keys (${count} removed)`);
  }
}

export const s3KeyStorage = new S3KeyStorage();
